// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uCah","rootMobile":"styles_rootMobile__3-E2J"};